
import { useEffect, useState } from 'react'
import { Boxes, Layers, Package } from 'lucide-react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddItemForm from '../items/add-popup'
import AddCategoryForm from '../category/add-popup'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import AddVariantForm from '../variants/add-popup'

const StockSupplyConfigPopup = ({ onClose = () => { }, onError = () => { }, onSuccess = () => { }, onSubmit = () => { }, currentData, tabIndex = null }) => {
    const apiCall = useApiCall();
    const [navIndex, setNavIndex] = useState(tabIndex || 0);
    const handleNavClick = (index) => {setNavIndex(index);};
    useEffect(() => {getDropdown();}, [])

    const navItems = [
        { label: "Categories", icon: <Layers size="1.2em" /> },
        { label: "Items", icon: <Package size="1.2em" /> },
        { label: "Variants", icon: <Boxes size="1.2em" /> },
    ];

    const [dropdowns, setDropdowns] = useState([]);
    const getDropdown = async () => {
        try {
            const [d1] = await Promise.all([apiCall({ method: "get", url: `get-supply-categories-list` }),]);
            let data = { categories: d1?.data, }
            setDropdowns(data);
        } catch (error) {
            console.warn("Error : ", error);
        }
    }

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => {
                                    return (
                                        <li
                                            key={i}
                                            className={`${navIndex === i ? Style.active : ""} ${tabIndex !== null ? navIndex === i ? "" : Style.disabled : ""}`}
                                            onClick={() => {
                                                if (tabIndex !== null) {
                                                    if (!navIndex === i) {
                                                        handleNavClick(i);
                                                    }
                                                } else {
                                                    handleNavClick(i);
                                                }
                                            }}
                                        >
                                            <div className={Style.icon}>{item.icon}</div>
                                            <span>{item.label}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>

                    {
                        navIndex === 0 && (
                            <AddCategoryForm
                                onClose={() => {onClose()}}
                                onError={onError}
                                onSuccess={onSuccess}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 1 && (
                            <AddItemForm
                                onClose={() => {onClose()}}
                                onError={onError}
                                onSuccess={onSuccess}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                                dropdowns={dropdowns}
                            />
                        )
                    }

                    {
                        navIndex === 2 && (
                            <AddVariantForm
                                onClose={() => {onClose()}}
                                onError={onError}
                                onSuccess={onSuccess}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                                dropdowns={dropdowns}
                            />
                        )
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default StockSupplyConfigPopup
